import {useEffect, useRef} from "react";

export const useWaitForFirstRender = (callback: () => void, delayAfterRerender = 100) => {
    const hasBeenInitialized = useRef(false);
    const initializeTimeout = useRef<ReturnType<typeof setTimeout> | null>();

    const initialize = () => {
        if (initializeTimeout.current) {
            clearTimeout(initializeTimeout.current);
        }

        initializeTimeout.current = setTimeout(() => {
            hasBeenInitialized.current = true;
            callback();
        }, delayAfterRerender);
    };

    if (hasBeenInitialized.current !== null && !hasBeenInitialized.current) {
        // every rerender should call initialize which delays initialization
        // this is necessary in case of dynamic content like placeholders, recalculating for mobile etc
        initialize();
    }

    useEffect(() => {
        initialize();
    }, []);
};
import {useEffect, useRef} from "react";

export const useWaitForFirstRender = (callback: () => void, delayAfterRerender = 100) => {
    const hasBeenInitialized = useRef(false);
    const initializeTimeout = useRef<ReturnType<typeof setTimeout> | null>();

    const initialize = () => {
        if (initializeTimeout.current) {
            clearTimeout(initializeTimeout.current);
        }

        initializeTimeout.current = setTimeout(() => {
            hasBeenInitialized.current = true;
            callback();
        }, delayAfterRerender);
    };

    if (hasBeenInitialized.current !== null && !hasBeenInitialized.current) {
        // every rerender should call initialize which delays initialization
        // this is necessary in case of dynamic content like placeholders, recalculating for mobile etc
        initialize();
    }

    useEffect(() => {
        initialize();
    }, []);
};
